import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { Cidade, Area, UF } from './models/cidade';
import { filtroDashboard } from '../dashboard/models/dashboard';


@Injectable({
    providedIn: 'root'
})

export class CidadeService {

    private environmentUrl: string = '';

    constructor(private httpClient: HttpClient) { this.environmentUrl = environment.ApiCore; }

    getCidades(): Observable<Cidade[]> {
        let url = this.environmentUrl + "/Cidade/";
        return this.httpClient.get<Cidade[]>(url);
    }

    getCidade(idCidade: string): Observable<Cidade> {
        let url = this.environmentUrl + "/Cidade/" + idCidade;
        return this.httpClient.get<Cidade>(url);
    }

    getAreas(): Observable<Area[]> {
        let url = this.environmentUrl + "/Area/";
        return this.httpClient.get<Area[]>(url);
    }

    getUFs(): Observable<Area[]> {
        let url = this.environmentUrl + "/Cidade/UF/";
        return this.httpClient.get<UF[]>(url);
    }

    addCidade(cidade: Cidade) {
        console.log(cidade);
        return this.httpClient.post(this.environmentUrl + "/Cidade", cidade);
    }

    updCidade(cidade: Cidade) {
        return this.httpClient.put(this.environmentUrl + "/Cidade", cidade);
    }

    delCidade(idCidade: string) {
        return this.httpClient.delete(this.environmentUrl + "/cidade/" + idCidade);
    }

    getCidadesDashboard(idEvento: string) {
        return this.httpClient.get<filtroDashboard[]>(this.environmentUrl + "/cidade/FiltroDashboard/" + idEvento);
    }
}


